import { createBrowserRouter, Navigate } from "react-router-dom";
import { Guest } from "./auth/components/Guest";
import { Protected, AdminOnly } from "./auth/components/Protected";
import { LoginPage } from "./auth/pages/LoginPage";
import { ChangePasswordPage } from "./auth/pages/ChangePasswordPage";
import { AdminLayout } from "./shared/layouts/AdminLayout";
import { PublicLayout } from "./shared/layouts/PublicLayout";
import { ListUser } from "./users/pages/ListUser";
import { UserForm } from "./users/components/UserForm";
import { SurveyList } from "./surveyList/pages/SurveyList";
import { SurveyForm } from "./surveyList/pages/SurveyForm";
import { SurveyStats } from "./surveyList/pages/SurveyStats";
import { SurveyResponses } from "./surveyList/pages/SurveyResponses";
import { PublicSurveyPage } from "./public/pages/PublicSurveyPage";

export const router = createBrowserRouter([
  // Public survey page - accessible via channel/publicId
  {
    path: "/s/:channel/:publicId",
    element: <PublicLayout />,
    children: [
      {
        index: true,
        element: <PublicSurveyPage />,
      },
    ],
  },
  // Legacy public survey page - accessible via unique ID only (no channel)
  {
    path: "/s/:publicId",
    element: <PublicLayout />,
    children: [
      {
        index: true,
        element: <PublicSurveyPage />,
      },
    ],
  },
  // Login page
  {
    path: "/login",
    element: (
      <Guest>
        <LoginPage />
      </Guest>
    ),
  },
  // Admin dashboard
  {
    path: "/admin",
    element: (
      <Protected>
        <AdminLayout />
      </Protected>
    ),
    children: [
      // Default redirect to surveys (SurveyList uses relative links, so it
      // must only render under /admin/surveys)
      {
        index: true,
        element: <Navigate to="surveys" replace />,
      },
      // Survey management
      {
        path: "surveys",
        element: <SurveyList />,
      },
      {
        path: "surveys/create",
        element: <SurveyForm />,
      },
      {
        path: "surveys/edit/:id",
        element: <SurveyForm />,
      },
      {
        path: "surveys/stats/:id",
        element: <SurveyStats />,
      },
      {
        path: "surveys/responses/:id",
        element: <SurveyResponses />,
      },
      // User management (admin only)
      {
        path: "users",
        element: (
          <AdminOnly>
            <ListUser />
          </AdminOnly>
        ),
      },
      {
        path: "users/create",
        element: (
          <AdminOnly>
            <UserForm />
          </AdminOnly>
        ),
      },
      {
        path: "users/edit/:id",
        element: (
          <AdminOnly>
            <UserForm />
          </AdminOnly>
        ),
      },
      // Change Password
      {
        path: "change-password",
        element: <ChangePasswordPage />,
      },
    ],
  },
  // Blank landing page
  {
    path: "/",
    element: <></>,
  },
  // Health check endpoint
  {
    path: "/status",
    element: <div>OK</div>,
  },
]);
